import React from 'react';
import { Button } from 'react-bootstrap';

/**Button handler and its logic */
export const ModalFormButton = (props) => {

    return !props.readOnly || (props.sourcesAllowed && props.type === "docLib") ?
        <Button
            style={{ float: "right" }}
            size="lg"
            variant="success"
            onClick={props.onSubmit}>
            {props.edit ? "Edit" : "Add"} Node
        </Button> : null;
};


// WEBPACK FOOTER //
// ./src/components/tree/node/ModalFormButton.js